// const CHANGE_VALUES = 'directOrder/CHANGE_VALUES';
const SET_SHIPMENT_KEYS = 'directOrder/SET_SHIPMENT_KEYS';

const changeTime$ = 'directOrder/changeTime$';
const selectTime$ = 'directOrder/selectTime$';
const onBlurTimePicker$ = 'directOrder/onBlurTimePicker$';

const changeDate$ = 'directOrder/changeDate$';

const changeAddress$ = 'directOrder/changeAddress$';
const cleanAddress$ = 'directOrder/cleanAddress$';

export default {
  // CHANGE_VALUES,
  SET_SHIPMENT_KEYS,

  changeTime$,
  selectTime$,
  onBlurTimePicker$,

  changeDate$,

  changeAddress$,
  cleanAddress$,
};
